export default {
  tags: {
    invoice: [],
    customer: [],
  },
};
